// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3hiLA","header":"PatientQuestionnaire_header__3HUa3","info":"PatientQuestionnaire_info__2Wk_V"};